
import axios from 'axios';
import { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';

import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
        
import { addManagerList2MemberList, addAssignList2MemberList, addNumber2MemberList, getChip, getFace, updateManagerSupervisorList, sortMemberList, isSelected, getServiceListItem } from '../Utilities/common';
import { DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

import mui from '../Imports/muiImports';
import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';
import { setSupervisorList, setManagerList } from '../Redux/allReducer';

export default function CardRightHandSide({serviceId}){

    const { setMemberList } = reducer;
    const { MemberTable, DataGrid1 } = component;  
    const { updateDBSupervisorList, updateDBManagerList, getAssignList, updateAssignList, getServiceList, getMemberList } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const memberList = useSelector((state) => state.all.memberList);
    const assignList = useSelector((state) => state.all.assignList);
    const supervisorList = useSelector((state) => state.all.supervisorList);

    const [selectedMemberList2, setSelectedMemberList2] = useState([]);
    const [selectedMemberList3, setSelectedMemberList3] = useState([]);

    const CustomComponent = ({ member }) => {
        // Assuming selectedMemberList2 is defined in the outer scope
        const isSupervisor = selectedMemberList2 && selectedMemberList2.some((listItem) => listItem.id === member.id);

        return (
            <span style={{ whiteSpace: 'nowrap' }}>
                {member.chineseName}
                {isSupervisor && <span style={{ marginLeft: '3px' }}>*</span>}
            </span>
        );
    };

    // const CustomComponent = ({ member }) => {

    //     const isSupervisor = selectedMemberList2 && selectedMemberList2.some((listItem) => listItem.id === member.id);

    //     return (
    //         <span>
    //             {member.chineseName}
    //             {isSupervisor && <span style={{ marginLeft: '5px' }}>*</span>}
    //         </span>
    //     );
    // };

    // const CustomComponent = ({ member }) => {
    //     return member.chineseName;
    // };

    useEffect(() => {
        if (memberList.length > 0 && supervisorList.length > 0) {
            const filteredSupervisorList = supervisorList.filter(listItem => listItem.serviceId === serviceId);
            const filteredMemberList = memberList.filter(memberListItem => filteredSupervisorList.some(listItem => listItem.memberId === memberListItem.id));
            setSelectedMemberList2(filteredMemberList);
        }        
        if (memberList.length > 0 && assignList.length > 0) {
            const filteredAssignList = assignList.filter(assignListItem => assignListItem.serviceId === serviceId);
            const filteredMemberList = memberList.filter(memberListItem => filteredAssignList.some(assignListItem => assignListItem.memberId === memberListItem.id));
            setSelectedMemberList3(filteredMemberList);
        }
    }, [serviceId, assignList, memberList]);

    return (
        <div>
            {selectedMemberList3.map((memberListItem, index) => (
                <div key={memberListItem.id || index}>
                    <CustomComponent member={memberListItem}/>
                </div>
            ))}
        </div>        
        // <DataTable 
        //     size={'small'}
        //     className="ultra-narrow-table"
        //     value={selectedMemberList3} 
        //     pt={{
        //         root: { style: { border: 'none' } },       // Removes outer container border
        //         thead: { style: { display: 'none' } },      // Removes header border wrapper
        //         headerCell: { style: { border: 'none' } }, // Removes individual header cell borders
        //         bodyRow: { style: { border: 'none' } },    // Removes horizontal row lines
        //         rowCell: { style: { border: 'none' } },    // Removes vertical column lines / cell borders
        //         tfoot: { style: { border: 'none' } }                
        //     }}
        // >      
        //     <Column body={(rowData) => <CustomComponent member={rowData}/>}></Column>
        // </DataTable>
    );

}